import {inject, Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import {CustomerService} from '@epg-apps/customer-api';
import {combineLatest, Observable, tap} from 'rxjs';
import {
  ContactDto,
  CustomerDetail,
  Environment,
  PageDto,
  StorageEnvironment,
} from '@epg-apps/cdh-models';
import {EnvironmentService} from '@epg-apps/environment-api';
import {CdhContactApiService} from '@epg-apps/cdh-contact-api';
import {StorageEnvironmentService} from '@epg-apps/storage-environment-api';

@Injectable({
  providedIn: 'root',
})
export class CustomerDetailResolver implements Resolve<
  [
    CustomerDetail,
    PageDto<Environment>,
    PageDto<ContactDto>,
    StorageEnvironment[],
  ]
> {
  customerService = inject(CustomerService);
  environmentService = inject(EnvironmentService);
  contactsService = inject(CdhContactApiService);
  storageEnvironmentService = inject(StorageEnvironmentService);

  resolve(
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _state: RouterStateSnapshot, // typescript-eslint warning is suppressed to stay conform to the interface Resolve, more dev friendly
  ): Observable<
    [
      CustomerDetail,
      PageDto<Environment>,
      PageDto<ContactDto>,
      StorageEnvironment[],
    ]
  > {
    const customerId = route.params['customerId'];
    const pageNumber = route.queryParams['pageNumber'] ?? 0;
    const pageSize = route.queryParams['pageSize'] ?? 10;
    const showHidden: boolean = route.queryParams['showHidden'] === 'true';
    console.log('show hidden: ', showHidden);
    return combineLatest([
      this.customerService.getCustomerDetails(customerId),
      this.environmentService.getEnvironmentsPage(
        customerId,
        pageNumber,
        pageSize,
        showHidden,
      ),
      this.contactsService.getContactsByCustomerId(customerId),
      this.storageEnvironmentService.getStorageEnvironments(customerId),
    ] as const).pipe(
      tap(
        ([customerDetail, environmentPage, contacts, storageEnvironments]) => {
          this.customerService.setCustomerDetails(customerDetail);
          this.environmentService.setEnvironmentPage(environmentPage);
          this.environmentService.setShowAll(showHidden);
          this.contactsService.setContacts(contacts);
          this.storageEnvironmentService.setStorageEnvironments(
            storageEnvironments,
          );
        },
      ),
    );
  }
}
